export class CalculoErroMensagemUtils {

  private static readonly MENSAGEM_GENERICA =
    'Não foi possível calcular o pedido desta empresa devido a inconsistência nos dados. Verifique as configurações de taxas, cobranças e colaboradores da empresa. Se o problema persistir, entre em contato com o suporte.';

  private static readonly MENSAGEM_TECNICA =
    /Cannot invoke|NullPointerException|java\.(lang|math|util)\.|br\.com\.|because the return value of|" is null|nested exception|\bat (java|br\.com)\./i;

  static formatar(mensagem: string): string {
    if (!mensagem?.trim()) {
      return mensagem;
    }

    const texto = mensagem.trim();

    if (texto.startsWith('Não foi possível calcular o pedido desta empresa')) {
      return texto;
    }

    if (this.MENSAGEM_TECNICA.test(texto)) {
      return this.MENSAGEM_GENERICA;
    }

    return texto;
  }
}
